/*
 * Copyright (c) Nexign, JSC, 2020-2022.
 */
/**
 * Styled components for Info Block
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.3.0
 */

import styled from 'styled-components';

import { IAttrStyled } from '@/main/types/globalTypes';
import { colors } from '@theme/index';

export const InfoBlockContainerStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: className || '',
}))<IAttrStyled>`
    display: inline-flex;
    align-items: flex-start;
    padding: 12px 24px 12px 16px;
`;

export const InfoBlockContainerWarningStyled = styled(InfoBlockContainerStyled)`
    border: 1px solid ${colors.infoBlockBorderColorWarning};
    border-left-width: 8px;
`

export const InfoBlockContainerErrorStyled = styled(InfoBlockContainerStyled)`
    border: 1px solid ${colors.infoBlockBorderColorError};
    border-left-width: 8px;
`

export const InfoBlockImgContainerStyled = styled.div`
    display: inline-block;
    height: 20px;
    width: 20px;
    margin-top: 4px;
    margin-right: 16px;
`;

export const InfoBlockImgContainerSuccessStyled = styled(InfoBlockImgContainerStyled)`
    height: 26px;
    width: 26px;
    border-radius: 50%;
    background-color: ${colors.backgroundColorSuccess};

    .info-icon {
        width: 100%;
        height: 100%;
    }
`

export const InfoBlockImgContainerSuccessBorderedStyled = styled(InfoBlockContainerStyled)`
    border: 1px solid ${colors.borderColorSuccess};
    border-left-width: 8px;

    ${InfoBlockImgContainerSuccessStyled} {
        min-width: 26px;
    }
`

export const InfoBlockMessageContainerStyled = styled.div`
    align-self: center;
`;

export const InfoBlockContainerInfoStyled = styled.div`
    display: grid;
    grid-template-columns: 40px 1fr;
    column-gap: 12px;
    padding: 20px 12px 20px 32px;
    border-radius: 12px;
    box-shadow: 0px 2px 9px rgba(0, 0, 0, 0.15);

    &.connection-deadline_info {
        margin-bottom: 24px;
    }
`;

export const InfoBlockImgInfoContainerStyled = styled.div`
    height: 40px;
    width: 40px;
`;
